import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../../components';
import { useForm, useModal } from '../../../hooks';
import { inviteOperatorStart } from '../../../redux/operators/operators.actions';
import { fetchWebsitesStart } from '../../../redux/websites/websites.actions';
import InviteOperatorModalInputs from '../InviteOperatorModalInputs';
import InviteOperatorModalWebsites from '../InviteOperatorModalWebsites';
import { validateInviteOperator } from './ValidateInviteOperator';
import useTranslation from 'hooks/useTranslation';

const mapState = ({ websitesData, userData }) => ({
  websites: websitesData.websites,
  profile: userData.profile,
});

const InviteOperatorModal = () => {
  const { websites, profile } = useSelector(mapState);
  const dispatch = useDispatch();
  const [visible, toggle] = useModal();
  const [accessLevel, setAccessLevel] = useState('user');
  const [selectedWebsiteIds, setSelectedWebsiteIds] = useState([]);
  const { isCreatorAdmin } = profile;
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  const handleInviteOperator = (values) => {
    let adaptedValues = {};

    for (let key in values) {
      if (typeof values[key] == 'string') {
        adaptedValues[key] = values[key].trim();
      } else {
        adaptedValues[key] = values[key];
      }
    }

    adaptedValues.email = adaptedValues.email.toLowerCase();

    const operator = {
      ...adaptedValues,
      accessLevel,
      selectedWebsiteIds: selectedWebsiteIds.join(','),
      handleToggleModal,
    };
    dispatch(inviteOperatorStart(operator));
  };
  const { values, errors, handleChange, handleSubmit, resetForm } = useForm(
    validateInviteOperator,
    handleInviteOperator,
    {
      position: '',
      fullName: '',
      email: '',
      mobile: '',
      password: '',
      confirmPassword: '',
    }
  );

  const handleToggleModal = (event) => {
    if (event) event.preventDefault();
    resetForm();
    toggle();
    setAccessLevel('user');
    if (!visible && websites.length === 0) {
      dispatch(fetchWebsitesStart());
    }
  };
  const renderAccessLevelSection = (
    <>
      <h5 className='modal__container__body__invite__form__title'>
        {t('OPERATOR_MODAL_ACCESS_LEVEL')}
      </h5>
      <div className='modal__container__body__invite__form__permission grid'>
        <div className='select'>
          <select
            name='permission'
            id='permission'
            value={accessLevel}
            onChange={(event) => setAccessLevel(event.target.value)}
          >
            <option value='user' defaultValue>
              {t('OPERATOR')}
            </option>
            {isCreatorAdmin && <option value='admin'>{t("ADMIN")}</option>}
          </select>
        </div>
      </div>
    </>
  );

  const renderFooterActions = (
    <div className='modal__container__footer__left'>
      <a
        href='#/'
        className='btn btn-tertiary'
        id='closeModal'
        onClick={handleToggleModal}
      >
        {t('OPERATOR_MODAL_CANCEL')}
      </a>
      <a
        href='#/'
        className='btn btn-primary'
        id='saveClose'
        onClick={handleSubmit}
      >
        {t('OPERATOR_MODAL_ADD')}
      </a>
    </div>
  );

  return (
    <>
      <Button onClick={handleToggleModal}>{t('ADD_OPERATOR')}</Button>
      <Modal visible={visible}>
        {profile.accountType == 0 && (
          <div className='package_overlay'>
            <div className='content' onClick={toggle}>
              {t('OVERLAY_TEXT')}
              <a href='#/' onClick={toggle} className='btn btn-primary'>
                {t('OVERLAY_CLOSE')}
              </a>
            </div>
          </div>
        )}
        <ModalHeader title={t('ADD_OPERATOR')} />
        <ModalBody>
          <div className='modal__container__body__invite'>
            <div className='modal__container__body__invite__form'>
              <form className='' noValidate onSubmit={handleSubmit}>
                <InviteOperatorModalInputs
                  errors={errors}
                  values={values}
                  handleChange={handleChange}
                  isInviteOperator={true}
                />
                <InviteOperatorModalWebsites
                  selectedWebsiteIds={selectedWebsiteIds}
                  setSelectedWebsiteIds={setSelectedWebsiteIds}
                />
                {renderAccessLevelSection}
              </form>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>{renderFooterActions}</ModalFooter>
      </Modal>
    </>
  );
};

export default React.memo(InviteOperatorModal);
